import React from 'react';
import '../../styles/styles.css';

export default function blackbar() {
  return (
    <div>
      
    </div>
  )
}
